<script setup lang="ts">
import { useToast } from '~/composables/useToast';
import { useRouter } from 'nuxt/app';

const { visible, message, color, timeout, isAuthError, hideToast, toasts, removeToast } = useToast();
const router = useRouter();

// 기존 단일 토스트 클릭 핸들러
const handleToastClick = () => {
	if (isAuthError.value) {
		router.push("/"); // 인증 오류인 경우 로그인 페이지로 이동
	}
	hideToast(); // 토스트 숨기기
};

// 다중 토스트 클릭 핸들러
const handleMultiToastClick = (toastItem: any, index: number) => {
	if (toastItem.isAuthError) {
		router.push("/"); // 인증 오류인 경우 로그인 페이지로 이동
	}
	// Vue reactivity를 위해 배열 전체를 새로 할당하여 visible 변경
	toasts.value = toasts.value.map((t, i) => 
		i === index ? { ...t, visible: false } : t
	);

	// 애니메이션 완료 후 제거
	setTimeout(() => {
		removeToast(toastItem.id);
	}, 300);
};
</script>

<template>
	<!-- 기존 단일 토스트 (하위 호환성을 위해 유지) -->
	<v-snackbar
		v-model="visible"
		:color="color"
		:timeout="timeout"
		:location="'top'"
		transition="slide-y-transition"
		@click="handleToastClick"
	>
		<div class="toast-text">{{ message }}</div>
	</v-snackbar>

	<!-- 다중 토스트 컨테이너 -->
	<div class="multi-toast-container">
		<v-snackbar
			v-for="(toast, index) in toasts"
			:key="toast.id"
			v-model="toast.visible"
			:color="toast.color"
			:location="'top'"
			transition="slide-y-transition"
			:style="{ 
				position: 'fixed',
				top: `${16 + index * 70}px`,
				zIndex: 9999 - index
			}"
			@click="handleMultiToastClick(toast, index)"
		>
			<div class="toast-text">{{ toast.message }}</div>
		</v-snackbar>
	</div>
</template>

<style scoped>
.toast-text {
	text-align: center;
	color: white;
}
</style>